import { IOrganization } from '@/fsd/entities/organization/model/types/types';
import { IProduct } from '@/fsd/entities/product';
import { IWarehouse } from '@/fsd/entities/warehouse';
import { FilterField } from '@/fsd/shared/ui/filter-panel';
import { REMAINDERS_FILTER_OPTIONS } from '../../model/consts/remaindersFilterOprtions';
import styles from '../../ui/Remains/Remains.module.scss';
import { getRemainsListFilterFieldsOptions } from './getRemainsListFilterFieldsOptions';

interface IParams {
  organizations?: IOrganization[];
  products?: IProduct[];
  warehouses?: IWarehouse[];
}

export const getRemainsListFilterFields = ({
  organizations,
  products,
  warehouses,
}: IParams): FilterField[] => {
  const {
    organizationsOptions,
    productOptions,
    warehousesOptions,
    categoriesOptions,
  } = getRemainsListFilterFieldsOptions({
    organizations,
    products,
    warehouses,
  });

  return [
    // {
    //   key: 'date',
    //   label: 'Дата',
    //   type: 'dateRange',
    //   className: `${styles.filterItem} ${styles.date}`,
    // },
    {
      key: 'organisation_ids',
      label: 'Организация',
      type: 'multiselect',
      options: organizationsOptions,
      className: `${styles.filterItem} ${styles.organization}`,
      isUseInput: true,
    },
    {
      key: 'warehouse_ids',
      label: 'Склад',
      type: 'multiselect',
      options: warehousesOptions,
      className: `${styles.filterItem} ${styles.warehouse}`,
      isUseInput: true,
    },
    {
      key: 'stock_state',
      label: 'Остаток',
      type: 'select',
      options: REMAINDERS_FILTER_OPTIONS,
      className: `${styles.filterItem} ${styles.remainder}`,
    },
    {
      key: 'categories',
      label: 'Категория',
      type: 'multiselect',
      options: categoriesOptions,
      className: `${styles.filterItem} ${styles.secondLine} ${styles.category}`,
      isUseInput: true,
    },
    {
      key: 'product_ids',
      label: 'Товар',
      type: 'multiselect',
      options: productOptions,
      className: `${styles.filterItem} ${styles.secondLine} ${styles.product}`,
      isUseInput: true,
    },
    {
      key: 'vendor_code',
      label: 'Артикул',
      type: 'input',
      className: `${styles.filterItem} ${styles.secondLine} ${styles.article}`,
    },
    {
      key: 'barcode',
      label: 'Баркод',
      type: 'input',
      className: `${styles.filterItem} ${styles.secondLine} ${styles.barcode}`,
    },
  ];
};
